import { Image } from "@components/core/Image";

import { getCountryCodeFromLocale } from "./flagMappings";

export function getDynamicFlagURL(locale: string) {
  return `https://eleven-public-cdn.elevenlabs.io/images/flags/circle-flags/${getCountryCodeFromLocale(locale)}.svg`;
}

export default function DynamicFlag({
  locale,
  size = 24,
  className,
  alt = `Flag for ${locale}`,
}: {
  alt?: string;
  className?: string;
  locale: string;
  size?: number | null;
}) {
  return (
    <Image
      alt={alt}
      className={className}
      height={512}
      src={getDynamicFlagURL(locale)}
      style={
        size
          ? {
              width: size,
              height: size,
            }
          : undefined
      }
      width={512}
    />
  );
}
